<script setup lang="ts">
const benefits = [
  {
    title: 'Validasi Alamat Otomatis',
    description: 'Minimalkan retur akibat salah input alamat.',
    icon: 'material-symbols:pin-drop-outline',
    iconSize: '33px'
  },
  {
    title: 'Tracking Retur Real-Time',
    description: 'Pantau status paket dari failed hingga returned.',
    icon: 'material-symbols:timer-outline',
    iconSize: '33px'
  },
  {
    title: 'Auto Reminder ke Buyer',
    description: 'Notifikasi otomatis mempercepat konfirmasi retur.',
    icon: 'material-symbols:notifications-outline',
    iconSize: '33px'
  },
  {
    title: 'Reason Classification & Analytics',
    description: 'Analisis penyebab retur berdasarkan data akurat.',
    icon: 'material-symbols:receipt-outline',
    iconSize: '33px'
  },
  {
    title: 'SLA Monitoring & Notifications',
    description: 'Pantau ketepatan proses retur sesuai KPI operasional.',
    icon: 'material-symbols:monitor-outline',
    iconSize: '33px'
  },
  {
    title: 'Pusat Komunikasi & Tiket',
    description: 'Kelola interaksi antar tim & pelanggan di satu tempat.',
    icon: 'material-symbols:campaign-outline',
    iconSize: '33px'
  }
]

const section = [
  {
    tag: 'SAFD',
    title: 'Success Attempt Failed Delivery',
    description: 'Beberapa penyebab retur dari seller/buyer',
    titleClass: 'lg:text-right lg:flex-row-reverse',
    class: 'lg:order-first',
    itemsClass: 'lg:items-end',
    items: [
      'Alamat penerima salah/tidak lengkap',
      'Packing paket tidak sesuai',
      'Paket termasuk daftar barang terlarang',
      'Penerima ambil paket sendiri',
      'Penerima tidak berada di lokasi',
      'Penerima tidak bisa dihubungi'
    ]
  },
  {
    tag: 'FAFD',
    title: 'Failed Attempt Failed Delivery',
    description: 'Beberapa penyebab retur dari pihak ekspedisi pengiriman',
    class: 'lg:order-last',
    itemsClass: 'lg:items-start',
    items: [
      'Paket Belum Diantar',
      'Kurir ambil paket tanpa persetujuan',
      'Resi rusak atau tidak jelas',
      'Pelacakan paket tidak informatif',
      'Kurir tidak mau mengantar paket',
      'Dibatalkan Kurir'
    ]
  }
]
</script>

<template>
  <section class="bg-surface-container-low">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Semua Kendali Retur, dalam Satu Sistem Terpadu"
      />
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(benefit, index) in benefits"
          :key="index"
          :icon="benefit.icon"
          :icon-size="benefit.iconSize"
          :title="benefit.title"
          :description="benefit.description"
        />
      </div>
      <div class="grid lg:flex gap-5 lg:gap-10 items-center">
        <div class="flex-1 hidden lg:block lg:order-2 shrink-0">
          <UiCard
            class="relative text-primary rounded-3xl overflow-hidden"
            body-class="flex flex-col items-center"
          >
            <span
              class="w-3/4 block aspect-square absolute top-0 bg-primary/30 rounded-full blur-xl -translate-y-1/2 left-1/2 -translate-x-1/2"
            ></span>
            <div
              class="bg-primary text-on-primary p-3 relative rounded-full inline-flex"
            >
              <Icon name="material-symbols:undo" size="32px" />
            </div>
            <div class="text-lg font-bold mt-3">RMS</div>
            <div class="flex flex-nowrap justify-center shrink-0 w-64">
              Return Management System
            </div>
          </UiCard>
        </div>
        <div
          v-for="(sec, key) in section"
          :key="`sec-${key}`"
          :class="cn('grow space-y-5', sec.class)"
        >
          <div :class="cn('flex items-center gap-3', sec.titleClass)">
            <div
              class="bg-error-container text-error text-lg font-black rounded-full px-3 py-2"
            >
              {{ sec.tag }}
            </div>
            <div>
              <div class="text-sm font-semibold">
                {{ sec.title }}
              </div>
              <div class="text-sm">
                {{ sec.description }}
              </div>
            </div>
          </div>
          <div :class="cn('flex flex-col gap-3', sec.itemsClass)">
            <div
              v-for="(item, k1y) in sec.items"
              :key="`sec-${sec}-${k1y}`"
              class="pl-1.5 py-1.5 pr-3 bg-error-container group text-sm hover:bg-error hover:text-on-error transition-all rounded-full flex gap-1 font-medium items-center"
              :class="{
                'lg:mr-2': key === 0 && k1y == 0,
                'lg:mr-3': key === 0 && (k1y == 1 || k1y == 4),
                'lg:mr-4': key === 0 && (k1y == 2 || k1y == 3),
                'lg:ml-2': key === 1 && k1y == 0,
                'lg:ml-3': key === 1 && (k1y == 1 || k1y == 4),
                'lg:ml-4': key === 1 && (k1y == 2 || k1y == 3)
              }"
            >
              <div
                class="bg-on-error text-error p-0.5 rounded-full group-hover:rotate-180 transition-all"
              >
                <Icon name="material-symbols:close" size="16px" />
              </div>
              <span class="grow flex flex-nowrap">{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
    </UiContainer>
  </section>
</template>
